var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"election-setup-card card"},[(! _vm.isChair)?_c('div',{staticClass:"non-chair"},[_c('election-display-card')],1):_c('div',{staticClass:"chair"},[(_vm.isInEventEditingMode)?_c('event-edit-card'):_c('election-display-card'),_vm._v(" "),(_vm.isInEventEditingMode)?_c('candidate-field-config-card'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }